import { observer } from "mobx-react-lite";
import CustomControl from "./CustomControl";
import BaseMapDropdown from "../header/BaseMapDropdown";

function BaseMapMapControl() {
    return (
        <CustomControl>
            <BaseMapDropdown />
        </CustomControl>
    );
}

export default observer(BaseMapMapControl);